import script from "./Custom.vue?vue&type=script&setup=true&lang=js"
export * from "./Custom.vue?vue&type=script&setup=true&lang=js"

import "./Custom.vue?vue&type=style&index=0&id=dbc01d6c&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-dbc01d6c"]])

export default __exports__